"use client";

import { Button } from "@heroui/button";
import { Link } from "@/i18n/routing";
import { useRouter } from "@/i18n/routing";
import { useModal } from "./modal-context";
import ComingSoon from "./modals/coming-soon-modal";
import { useTransition } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
interface MenuButtonProps {
  icon: string;
  text: string;
  link: string;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function MenuButton({ icon, text, link, setIsOpen }: MenuButtonProps) {
  // const router = useRouter();
  const { openModal } = useModal();
  const t = useTranslations();
  const pressHandler = (e: any) => {
    if (link === "coming-soon") {
      e.preventDefault();
      setIsOpen && setIsOpen(false);
      openModal(<ComingSoon />, t("coming-soon-0"));
      return;
    }
    setIsOpen && setIsOpen(false);
    // router.push(link, { scroll: false });
  };
  return (
    <Button
      as={Link}
      href={link}
      onPress={pressHandler}
      size="lg"
      className="flex w-full items-center justify-between bg-[#0F413A] px-3"
    >
      <div className="flex items-center gap-x-2">
        {["recents", "promotion"].includes(icon) ? (
          <Image
            src={`/icons/icon-${icon}.svg`}
            width={32}
            height={32}
            alt={icon}
            className="size-[1.5rem] fill-white invert filter sm:size-[2rem]"
          />
        ) : (
          <span className={`${icon} text-[1.5rem] sm:text-[2rem]`} />
        )}
        <span className="text-sm md:text-medium">{text}</span>
      </div>
      <span className="icon-icon7 text-[1.5rem] sm:text-[2rem]" />
    </Button>
  );
}
